"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const autosave_1 = require("../../../../hooks/autosave");
const TaskPage_1 = require("../../base/TaskPage");
const index_1 = require("../../../../index");
const react_redux_1 = require("react-redux");
const viewstate_1 = require("../../../../entities/viewstate");
const constants_1 = require("../../../../tasks/constants");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const Spacer_1 = require("../../../components/spacer/Spacer");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const errorNotifier_1 = require("../../../../hooks/errorNotifier");
const actionCallback_1 = require("../../../../hooks/actionCallback");
exports.default = (props) => {
    const { entityActions, availabilityTask } = React.useContext(index_1.AppContext);
    const { dispatch } = (0, react_redux_1.useStore)();
    const { property, viewState } = (0, autosave_1.useAutoSaveProperty)(props.propertyId);
    const [lastSaved, setLastSaved] = React.useState(null);
    const [saving, setSaving] = React.useState(false);
    // This is the action that the Calendar page in portal uses to create/delete events:
    // https://github.com/TravelNest/portal/blob/40f11b4580c698885d7c240716973710509b3bfa/src/view/pages/calendar/Calendar.tsx#L145
    const resolveEventError = (0, errorNotifier_1.useActionErrorNotifier)('RESOLVE_EVENTS_REQUEST', 'RESOLVE_EVENTS_FAILURE');
    // Fetch property summary here since re-validation is performed by the client API on nights available
    (0, actionCallback_1.useActionCallback)(() => {
        dispatch(entityActions.propertySummary.getById(props.propertyId));
        setSaving(false);
        setLastSaved(new Date());
    }, 'RESOLVE_EVENTS_RECEIVE');
    (0, actionCallback_1.useActionCallback)(() => {
        setSaving(true);
    }, 'RESOLVE_EVENTS_REQUEST');
    (0, actionCallback_1.useActionCallback)(() => {
        setSaving(false);
    }, 'RESOLVE_EVENTS_FAILURE');
    return (React.createElement(TaskPage_1.TaskPage, { task: constants_1.Tasks.BOOKING_AVAILABILITY, property: property, viewState: (0, viewstate_1.combineViewStates)(viewState, saving ? viewstate_1.ViewState.SAVING : viewstate_1.ViewState.IDLE), updaterError: resolveEventError, lastSaved: lastSaved },
        React.createElement(HorizontalRule_1.HorizontalRule, null),
        React.createElement(Spacer_1.Spacer, { spacing: "large" }),
        React.createElement(MarginWrapper_1.MarginWrapper, null, availabilityTask(props.propertyId))));
};
//# sourceMappingURL=AvailabilityTaskPage.js.map